module.exports = __webpack_public_path__ + "media/case1_mob.097d74c5.mp4";